import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const COMPLAINT_TYPE_ENDPOINT = '/api/v1/complaint-types';

const rejectRequest = (error, thunkApi) =>
  thunkApi.rejectWithValue({
    status: error?.response?.status ?? error?.status,
    message:
      error?.response?.data?.message ??
      error?.response?.data?.error ??
      error?.message ??
      'Something went wrong',
  });

export const fetchComplaintTypes = createAsyncThunk(
  'complaintType/fetchAll',
  async (_, thunkApi) => {
    try {
      const response = await api.get(COMPLAINT_TYPE_ENDPOINT);
      console.log('[fetchComplaintTypes] API response:', response.data);
      return response.data;
    } catch (error) {
      console.error('[fetchComplaintTypes] API request failed:', error);
      return rejectRequest(error, thunkApi);
    }
  },
);

export const fetchComplaintTypeById = createAsyncThunk(
  'complaintType/fetchById',
  async (id, thunkApi) => {
    try {
      const response = await api.get(`${COMPLAINT_TYPE_ENDPOINT}/${id}`);
      
      return response.data;
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);

export const createComplaintType = createAsyncThunk(
  'complaintType/create',
 async ({ payload, onSuccess, onFail }, thunkApi) => {
    try {


      const data={
        code:payload.categoryName, 
        name: payload.categoryName,
        description: payload.description,
        tatMinutes: payload.tatMinutes,
        isActive: payload.active,
        accessType: payload.visibilityType,
      roleIds: payload.roles.map((role) => parseInt(role, 10)),
      // roleIds:[],
      }
      // console.log('createComplaintType payload:', payload ,'api token:', api.defaults.headers.Authorization);
      const response = await api.post(COMPLAINT_TYPE_ENDPOINT, data);
      if(onSuccess && typeof onSuccess === 'function'){
        onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      console.log('createComplaintType error:', error);
      if(onFail && typeof onFail === 'function'){
        onFail(error);
      }
      return rejectRequest(error, thunkApi);
    }
  },
);

export const updateComplaintType = createAsyncThunk(
  'complaintType/update',
  async ({ id, data, onSuccess, onFail  }, thunkApi) => {
    try {
      const response = await api.patch(`${COMPLAINT_TYPE_ENDPOINT}/${id}`, data);
      if(onSuccess && typeof onSuccess === 'function'){
        onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      console.log('updateComplaintType error:', error);
      if(onFail && typeof onFail === 'function'){
        onFail(error);
      }
      return rejectRequest(error, thunkApi);
    }
  },
);

export const deleteComplaintType = createAsyncThunk(
  'complaintType/delete',
  async (id, thunkApi) => {
    try {
      const response = await api.delete(`${COMPLAINT_TYPE_ENDPOINT}/${id}`);
      return { id, data: response.data };
    } catch (error) {
      return rejectRequest(error, thunkApi);
    }
  },
);


